<app-promotion-leaderboard-view [type]="promotionType" [promotionId]="promotionId" [nickname]="nickname"
                                [brandId]="brandId" [siteId]="siteId" [playerLimit]="playerLimit"
                                [prizeVisibility]="prizeVisibility"
                                [onlyCoin]="onlyCoin"
                                [hideSymbol]="hideSymbol"
                                [hideCustomSymbol]="hideCustomSymbol"
                                [hideRank]="hideRank"
                                [focusFirstPlayer]="focusFirstPlayer"
                                [optInGroupName]="optInGroupName"
                                [leaderboardType]="leaderboardType"
                                [backgroundColor]="backgroundColor"
></app-promotion-leaderboard-view>
